export const EMPTY_REFERENCE = {
  fullname: '',
  jobTitle: '',
  companyName: '',
  email: '',
  phone: '',
  candidateRelationship: '',
  workDuration: '',
}

export const MAX_REFERENCES = 3
